import { Button } from '@storeblocks/button';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';

export const OpenPrintDialogButton: FC = () => {
  const texts = useTexts();

  return (
    <div>
      <Button iconRight="print" onClick={() => window.print()}>
        {texts.pages.presentation.reportPreview.goToPrint}
      </Button>
    </div>
  );
};
